import React from 'react'
import { Field } from 'redux-form';
import ViewFluxoKamban from './components/ViewFluxoKamban'
import { InputPicker, DinamicComponents, Item, painel } from 'scorpion-core'
import EditorCodigo from '../../editor/EditorCodigo'
function componentRelEspelho(comp, dados) {
    return painel([
        [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: dados[comp.field] }]
    ], { widths: ['*'] })

}

function component(item) {
    let op = item.opcoes.slice();
    if (item.permiteRemover) {
        op.push(null)

    }

    if (item.requerido) {
        return (<Item key={item.sha} style={{ flex: 1 }}>
            <Field name={item.field} placeholder={item.label} itens={op} toStringItem={(item) => item} component={InputPicker} validade={[required]} />
        </Item>)
    }

    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} placeholder={item.label} itens={op} toStringItem={(item) => item} component={InputPicker} />
    </Item>)
}

const modelo = {
    field: "fluxoKanban",
    label: "Fluxo Kanban",
    typeComponente: "fluxoKanban",
    opcoes: ["Entrada", "Analise", "Aguard Desenvolvimento", "Desenvolvimento", "Testes", "Aguard Versão", "Concluido"],
    fieldKanban: "titulo",
    ordenadorAux: "",
    requerido: false,
    permiteRemover: true,
    someteComValor: true,
    codePrimario: `function getViewPrimario(obj,fase){}`,
    codeSecundario: `function getViewSecundario(obj,fase){}`,
}

const comp = {
    typeComponente: "fluxoKanban",
    configView: {
        nome: "Fluxo Kanban",
        modelo,
        editores: {
            opcoes: DinamicComponents.EditorLista,
            codePrimario: EditorCodigo,
            codeSecundario: EditorCodigo,
        },
    },
    componentRelEspelho,
    component,
    geraSubConfig: (form, c) => {
        let propsAdd = { rota: '/' + form.rota, someteComValor: c.someteComValor, titulo: c.label, customFormUid: form.uid, fluxo: c.field, propOrdemAux: c.ordenadorAux, fieldKanban: c.fieldKanban, confFluxo: c }
        return { rota: c.field, permissao: c.permissao ? form.permissao + "." + c.permissao : "", nomeMenu: c.label, ordemMenu: c.label, subDe: "", component: ViewFluxoKamban, propsAdd }
    }

}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/FluxoKamban.js